import React, { Component } from "react";
import { numberWithCommas } from "../../../../helpers/dataHelpers";

import { Table, Navbar, Nav, Button } from "react-bootstrap";
import { openModal } from "../../../../store/actions/ModalActions";

import ExpiredViewFilter from "../../view_filters/Sales/ExpiredViewFilter";
import moment from "moment";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import { moduleNames } from "../../../../helpers/dashboardModuleNames";
import { DashboardContext } from "../../dashboard_context";

const customTextStyle = { textAlign: "center" };

class ExpiredPawn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
  }

  renderTableRows = (data) => {
    return (
      <React.Fragment>
        <div style={{ color: "#F4511E" }}>
          {moment(data.key.covered_date).format("MMMM DD YYYY")}
        </div>
        <tr>
          <td className="text-center">
            <React.Fragment>
              <h4 style={customTextStyle}>
                {numberWithCommas(data.value.totalPieces)}
              </h4>
            </React.Fragment>
          </td>
          <td className="text-center">
            <React.Fragment>
              <h4 style={customTextStyle} className="text-monospace mr-1">
                {`₱${numberWithCommas(data.value.totalPrincipal)}`}
              </h4>
            </React.Fragment>
          </td>
        </tr>
      </React.Fragment>
    );
  };

  render() {
    return (
      <div>
        <Navbar>
          <Navbar.Brand
            className="h5"
            style={{ color: this.context.titleColor }}
          >
            {this.props.listTitle}
          </Navbar.Brand>
          <Navbar.Text>
            <p className="small">{this.props.subTitle}</p>
          </Navbar.Text>
          <Navbar.Collapse className="align-content-between">
            <Nav className="mr-auto" />
            <Nav>
              <Button
                className="m-1"
                size="sm"
                variant="outline-secondary"
                onClick={() => {
                  openModal({
                    title: "View Expired Pawns",
                    size: "lg",
                    custom: false,
                    currentComponent: <ExpiredViewFilter />,
                  });
                }}
              >
                Filter
              </Button>
              <ModuleLocked
                Lock={() => this.context.Lock(moduleNames.salesExpired)}
                Unlock={() => this.context.Unlock(moduleNames.salesExpired)}
                isLocked={this.context.salesExpiredLocked}
              />
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <Table borderless size="sm">
          <tbody>
            {this.props.list.map((data) => {
              return this.renderTableRows(data);
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

ExpiredPawn.contextType = DashboardContext;
export default ExpiredPawn;
